import { Clickable, P } from '@ahmdigital/ui';

import constants from '../../../../ahm-constants';
import styles from './styles.module.sass';

const TravelInsuranceSmallDisclaimer = () => (
  <div className={styles.termsAndConditions}>
    <P>
      Limits, sub-limits, exclusions and conditions apply. This is general advice only. This product is distributed by
      Australian Health Management Group Pty Limited (ABN 96 003 683 298, AR 266711) and administered by Travel
      Insurance Partners Pty Limited (ABN 73 144 049 230, AFSL 360138). Travel insurance is underwritten by Zurich
      Australian Insurance Limited (ABN 13 000 296 640, AFSL 232507). Please consider your own needs and the{' '}
      <Clickable inNewTab to={constants.URLS.HELP.TRAVEL_INSURANCE_FORMS_AND_GUIDES}>
        Combined FSG/PDS
      </Clickable>{' '}
      to decide if this product is right for you. For information on the Target Market and{' '}
      <Clickable inNewTab to={constants.URLS.HELP.TRAVEL_INSURANCE_FORMS_AND_GUIDES}>
        Target Market Determinations
      </Clickable>
      , visit ahm.com.au/travel-insurance/forms-and-guides.
    </P>
  </div>
);

export default TravelInsuranceSmallDisclaimer;
